module.exports = __webpack_public_path__ + "img/girl2.813d732e.jpg";